








import settings from '../settings.coffee'

export default {
    "name": "EtherPad"
    "props": {
        "padkey": String
        "height": String
    }
    "computed":
        "style": ()->
            return {
                "height": this.height
            }

        "etherpadLink": ()->
            return settings.etherpadUrl+this.padkey+"?toc=true" + "&noColors=true&showControls=true&showLineNumbers=false&userName=" + encodeURI(this.$store.state.profile.data.fullname) 
    #"watch":
    #    "$store.state.selected_establishment_uid": (newV, oldV)->
            #console.log("watch", this.$refs.iframe)
            #this.$refs.iframe.contentWindow.location.hash = newV
}
